var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueCustomTooltip',{attrs:{"label":`${_vm.$ml.get('multipliedScore')} ${_vm.bonusScoreValue}x`}},[_c('span',{staticClass:"ico ico-locked"},[_c('img',{staticClass:"ico-12",attrs:{"src":require("../assets/icons/star-icon.svg")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }